import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CreatePath from './screens/CreatePath';
import PlayGame from './screens/PlayGame';
import HomePage from './screens/HomePage';
import GameCompletedScreen from './screens/GameCompletedScreen';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/game/create" element={<CreatePath />} />
        <Route path="/game/auto/:sessionId" element={<PlayGame />} />
        <Route path="/game/auto/:sessionId/completed" element={<GameCompletedScreen />} />
        <Route path="/game/:id" element={<PlayGame />} />
        <Route path="/game/:id/completed" element={<GameCompletedScreen />} />
      </Routes>
    </Router>
  );
}

export default App;